import axios from "axios";
var auth = {
  request(formData) {
    let url = process.env.VUE_APP_API + "/auth";
    return axios.post(url, formData);
  }
};
export default auth;
